import styled from 'styled-components';
import { themeMode, spacing, color, palette, variant } from '../../utils/theme.es.js';
import { CheckboxPrimitive } from './CheckboxPrimitive/CheckboxPrimitive.es.js';
var sizeStyles = variant({
  prop: "size",
  variants: {
    sm: {
      width: spacing(4),
      height: spacing(4)
    },
    md: {
      width: spacing(4),
      height: spacing(4)
    },
    lg: {
      width: spacing(6),
      height: spacing(6)
    }
  }
});
var Control = styled(CheckboxPrimitive.Control).withConfig({
  componentId: "sc-1xtyf4m-0"
})(["display:flex;justify-content:center;align-content:center;align-items:center;border-radius:2px;overflow:hidden;position:relative;flex-shrink:0;transition:opacity 200ms ease-in;svg{opacity:0;color:", ";transition:all 200ms ease-in;}border:1px solid ", ";color:", ";", ";"], themeMode({
  light: palette("neutral.50"),
  dark: palette("neutral.900")
}), themeMode({
  light: palette("neutral.400"),
  dark: palette("neutral.500")
}), themeMode({
  light: palette("neutral.900"),
  dark: palette("neutral.50")
}), sizeStyles);
Control.displayName = "Checkbox.Control";
var labelSizeStyles = variant({
  prop: "size",
  variants: {
    sm: {
      fontSize: "sm",
      lineHeight: "sm"
    },
    md: {
      fontSize: "md",
      lineHeight: "md"
    },
    lg: {
      fontSize: "lg",
      lineHeight: "md"
    }
  }
});
var Label = styled(CheckboxPrimitive.Label).withConfig({
  componentId: "sc-1xtyf4m-1"
})(["margin-left:", ";user-select:none;color:", ";color:", ";", ";"], spacing("xs"), color("text.base"), function (_ref) {
  var isDisabled = _ref.isDisabled;
  return isDisabled ? themeMode({
    light: palette("neutral.400"),
    dark: palette("neutral.500")
  }) : "text.base";
}, labelSizeStyles);
Label.displayName = "Checkbox.Label";
var Checkbox = styled(CheckboxPrimitive.Root).withConfig({
  componentId: "sc-1xtyf4m-2"
})(["position:relative;display:inline-flex;flex-direction:row;align-items:center;padding:", ";&[data-state='checked']:not([data-disabled='true']) > div:first-of-type{background-color:", ";border-color:", ";&:hover{background-color:", ";border-color:", ";}svg{opacity:1;}}&[data-disabled='true'][data-state='checked'] > div:first-of-type{background-color:", ";border-color:", ";&:hover{background-color:", ";border-color:", ";}svg{opacity:1;}}&[data-disabled='true'] > div:first-of-type{border-color:", ";&:hover{border-color:", ";}}&[data-invalid='true'] > div:first-of-type{border-color:", ";}& > div:first-of-type{&:hover{border-color:", ";}}&:hover{cursor:pointer;}&[data-disabled='true']{&:hover{cursor:not-allowed;}}"], spacing("xs"), themeMode({
  light: palette("neutral.900"),
  dark: palette("neutral.50")
}), themeMode({
  light: palette("neutral.900"),
  dark: palette("neutral.50")
}), themeMode({
  light: palette("neutral.700"),
  dark: palette("neutral.200")
}), themeMode({
  light: palette("neutral.700"),
  dark: palette("neutral.200")
}), themeMode({
  light: palette("neutral.400"),
  dark: palette("neutral.500")
}), themeMode({
  light: palette("neutral.400"),
  dark: palette("neutral.500")
}), themeMode({
  light: palette("neutral.400"),
  dark: palette("neutral.500")
}), themeMode({
  light: palette("neutral.400"),
  dark: palette("neutral.500")
}), themeMode({
  light: palette("neutral.400"),
  dark: palette("neutral.500")
}), themeMode({
  light: palette("neutral.400"),
  dark: palette("neutral.500")
}), palette("danger.500"), themeMode({
  light: palette("neutral.700"),
  dark: palette("neutral.200")
}));
Checkbox.displayName = "Checkbox";
export { Checkbox, Control, Label };